import { CLASS_CONSTATNTS as TYPES } from '../../organizedByType/actions/analyticsActions'
import { isMenuOpen } from './menu.selectors'

export const TOGGLE_MENU = '[menu] toggle menu'
export function toggleMenuAction() {
  return {
    type: TOGGLE_MENU,
  }
}

function sendMenuButtonClickAnalyticsAction(action) {
  return {
    type: TYPES.ANALYTICS.ACTIONS.CLICK_EVENT,
    state: {
      payload: {
        category: 'Navigation',
        action: `hamburger menu ${action ? 'open' : 'close'}`,
        label: 'none',
      },
    },
  }
}

export const toggleMenu = () => (dispatch, getState) => {
  dispatch(toggleMenuAction())
  dispatch(sendMenuButtonClickAnalyticsAction(isMenuOpen(getState())))
  if (typeof window.__uspapi === 'function') {
    window.__uspapi('uspPing', 1, function (obj, status) {
      if (status && obj.mode.includes('USP') && obj.jurisdiction.includes(obj.location.toUpperCase())) {
        let menu = document.getElementsByClassName('menu__static__links__container')
        menu[0].childNodes[menu[0].childNodes.length - 1].insertAdjacentHTML(
            'afterend',
            `<a class="menu__static__link__container" onclick="window.__uspapi('displayUspUi')" class="items-list__link" href="#">Do Not Sell My Info</a>`
        )
        window.__uspapi('setUspDftData', 1, function (obj, status) {
          if (!status) {
            console.log("Error: USP string not updated!")
          }
        });
      }
    });
  }
}



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/store/menu/menu.actions.js